<!-- eslint-disable -->
<template>
  <div id="app">
    <template-header v-if="showHeader"></template-header>
    <router-view v-if="DV_connectedToDB"/>
    <h1 style="margin: 5vw 5vh" v-else>Loading...</h1>
  </div>
</template>

<script>
/* eslint-disable */
import TemplateHeader from "./components/public/TemplateHeader"

export default {
  name: 'App',
  components: { TemplateHeader },
  data() {
    return {
      DV_connectedToDB: false
    }
  },
  mounted() {
    if (this.$route.path === "/" || 
        this.$route.path === "/login" ||
        this.$route.path === "/home~") {
      this.DV_connectedToDB = true;
    } else {
      setTimeout(this.checkConnection, 1000);
    }
  },
  methods: {
    checkConnection(retry_count=0) {
      var CI = this;
      if (window.G_firebase_auth.IV_id_token === "" || 
          window.G_web_gui_data.IV_user_info.uid === 0 ||
          (window.G_firebase_auth.IV_is_guest === true && 
          'token' in CI.$route.query === false)
        ) {
        if (retry_count >= 10) {
          localStorage.clear();
          const redirect_url = (location.pathname + location.search).substr(1)
          location.assign(window.location.origin + `/login?redirect_to=${redirect_url}`)
          return;
        }
        setTimeout(function() { CI.checkConnection(++retry_count) }, 1000);
        return;
      }
      this.DV_connectedToDB = true;
    }
  },
  computed: {
    showHeader() {
      return !this.$route.path.includes("device-interface");
    }
  }
}
</script>

<style>
  @import 'vue-awesome-notifications/dist/styles/style.css';
  #app {
    background: #bcbcbc;
    height: max-content;
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue